"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _ToastHelper = _interopRequireDefault(require("../../util/ToastHelper"));

var _FormComponent = _interopRequireDefault(require("./FormComponent"));

var _AppButton = _interopRequireDefault(require("./AppButton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var FormSubmitWrapper = /*#__PURE__*/function (_Component) {
  _inherits(FormSubmitWrapper, _Component);

  function FormSubmitWrapper(props) {
    var _this;

    _classCallCheck(this, FormSubmitWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormSubmitWrapper).call(this, props));
    _this.state = {
      textMessage: ''
    }; // Initial state

    _this.formHandler = props.formHandler;

    _this.formHandler.on('submitSuccess', function (data) {
      var customMessage = _this.props.getModalMessage(data);

      _this.setState({
        textMessage: customMessage || data.message || 'Action successful!' // redirect: true

      });

      if (props.onSuccess) {
        props.onSuccess(data);
      } else {
        setTimeout(function () {
          _this.setState({
            redirect: true
          });
        }, 2000);
      }
    });

    _this.formHandler.on('submitError', function (data) {
      var customMessage = _this.props.getModalMessage(data);

      _this.setState({
        textMessage: customMessage || data.message || 'Oops, something is wrong, you can not finish this action.'
      }, function () {
        _ToastHelper["default"].show(_this.state.textMessage);
      });
    });

    _this.formHandler.on('inputChange', function (data) {
      _this.setState({
        textMessage: ''
      }, function () {
        _ToastHelper["default"].close();
      });
    });

    return _this;
  }

  _createClass(FormSubmitWrapper, [{
    key: "_getButtonContent",
    value: function _getButtonContent() {
      if (this.formHandler.state.isLoading || this.state.redirect) {
        return _react["default"].createElement(_CircularProgress["default"], {
          className: "circle-progress",
          size: 30
        });
      }

      return _react["default"].createElement("span", null, this.props.buttonText);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.redirect && this.props.to) {
        return _react["default"].createElement(_reactRouterDom.Redirect, {
          to: this.props.to
        });
      }

      var buttonContent = this._getButtonContent();

      var formHandler = this.formHandler;
      return _react["default"].createElement("div", {
        style: {
          width: '100%'
        }
      }, _react["default"].createElement(_FormComponent["default"], {
        formHandler: formHandler
      }, this.props.children, this.props.renderActionButtons ? this.props.renderActionButtons(this.formHandler.state.isLoading) : _react["default"].createElement("div", {
        className: "submitButtonWrapper ".concat(this.props.changeSubmitButtonWrapper)
      }, _react["default"].createElement("div", {
        className: "form-button-container ".concat(this.props.buttonContainer)
      }, _react["default"].createElement(_AppButton["default"], {
        type: "submit"
      }, buttonContent)))));
    }
  }]);

  return FormSubmitWrapper;
}(_react.Component);

exports["default"] = FormSubmitWrapper;
FormSubmitWrapper.defaultProps = {
  buttonText: 'Save',
  getModalMessage: function getModalMessage() {
    return null;
  },
  click: function click() {
    return null;
  },
  buttonContainer: '',
  changeSubmitButtonWrapper: ''
};